export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10962.0816a435.jpg";